import { Component } from '@angular/core';

@Component({
  selector: 'app-pdq',
  templateUrl: './pdq.component.html',
  styleUrls: ['./pdq.component.css'],
  standalone: false,
})
export class PdqComponent {
  ip: string = '192.67.249.3';
  port: number = 8800;
}
